import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, useLocation } from "react-router-dom";
import { ColorModeContext, useMode } from "./theme/theme";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Triage from "./scenes/triage";
import CompletedTickets from "./scenes/complete";
import Notices from "./scenes/notices";
import Login from "./scenes/login/Login";
import HelpPage from "./scenes/help"; // ✅ NEW import

// ✅ Centralized API base URL with fallback
const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

// ✅ Custom protected route wrapper
const ProtectedRoute = ({ session, children }) => {
  const location = useLocation();
  if (!session) {
    return <Login redirectPath={location.pathname} />;
  }
  return children;
};

function App() {
  const [theme, colorMode] = useMode();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const res = await fetch("/auth/session", {
          credentials: "include",
        });

        const contentType = res.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          throw new Error("Invalid session response");
        }

        const data = await res.json();
        setSession(data?.username ? data : null);
      } catch (err) {
        console.error("Failed to fetch session:", err.message);
        setSession(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute session={session}>
                <div className="app">
                  <Sidebar session={session} />
                  <main className="content">
                    <Topbar session={session} />
                    <Routes>
                      <Route path="/" element={<Dashboard session={session} />} />
                      <Route path="/triage" element={<Triage session={session} />} />
                      <Route path="/complete" element={<CompletedTickets session={session} />} />
                      <Route path="/notices" element={<Notices session={session} />} />
                      <Route path="/help" element={<HelpPage session={session} />} /> {/* ✅ NEW route */}
                    </Routes>
                  </main>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;